import React from "react";
import { motion } from "framer-motion";
import "./ServiceSection.css";
import { useNavigate } from "react-router-dom"; 
const services = [
  { title: "Website Development", img: "https://static.wixstatic.com/media/d56fdc_b3a7025dc30145789f54e5384711e611~mv2.png/v1/crop/x_0,y_121,w_1200,h_772/fill/w_962,h_618,fp_0.50_0.50,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Web%20Developer%20Linkedin%20Post%20(4).png", link: "#" },
  { title: "Application Development", img: "https://static.wixstatic.com/media/d56fdc_2113593c01a14c57bc28eb265f06ff74~mv2.png/v1/fill/w_950,h_588,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Web%20Development%20Services%20Instagram%20Post%20(3).png", link: "#" },
  { title: "Software Development", img: "https://static.wixstatic.com/media/d56fdc_c71a3a78272b4bca9e60529f32faad3d~mv2.png/v1/fill/w_962,h_596,fp_0.50_0.39,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Purple%20White%20Simple%20Modern%20Web%20Development%20Instagram%20Post%20(1).png", link: "#" },
  { title: "Sales Solution", img: "https://static.wixstatic.com/media/d56fdc_467669d98fd244cab0731bd7c30e9e81~mv2.png/v1/crop/x_87,y_0,w_1746,h_1080/fill/w_962,h_596,fp_0.50_0.50,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Orange%20and%20Brown%20Illustration%20Business%20Report%20Presentation%20(12).png", link: "#" },
  { title: "Startup to Market Leader", img: "https://static.wixstatic.com/media/d56fdc_b0ea204de9ca457d99536d41500b31e3~mv2.png/v1/fill/w_920,h_596,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Orange%20and%20Brown%20Illustration%20Business%20Report%20Presentation%20(13).png", link: "#" },
  
];

const headingVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { 
      duration: 0.8, 
      ease: "easeOut" 
    }
  },
};

const cardContainerVariants = {
  hidden: { opacity: 1 },
  visible: { 
    opacity: 1, 
    transition: { 
      staggerChildren: 0.2,
      delayChildren: 0.4 
    } 
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 50, scale: 0.95 },
  visible: { 
    opacity: 1, 
    y: 0, 
    scale: 1,
    transition: { 
      duration: 0.6, 
      ease: "easeOut" 
    },
  },
};

export default function MarketingSolutions() {
    const navigate = useNavigate();
  return (
    <div className="marketing-solutions-section">
      <motion.h2 
        className="marketing-solutions-heading"
        variants={headingVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
      >
        TECH SOLUTIONS
      </motion.h2>

      <motion.div 
        className="marketing-solutions-cards-container"
        variants={cardContainerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        {services.map((service, index) => (
          <motion.div 
            className="marketing-solutions-card" 
            key={service.title} 
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
          >
            <div className="marketing-solutions-content-left">
              <h3 className="marketing-solutions-title">{service.title}</h3>
              <motion.button
                onClick={() => navigate("/lets-connect")}
                className="marketing-solutions-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Know More
              </motion.button>
            </div>
            <div className="marketing-solutions-content-right">
              <motion.img 
                src={service.img} 
                alt={service.title} 
                className="marketing-solutions-image" 
                loading="lazy"
                draggable="false"
                whileHover={{ scale: 1.1, rotate: 5 }}
              />
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}